

















































































import FlightRoute from "@/store/entities/flight/flightRoute";
import { Component, Vue } from "vue-property-decorator";
@Component({})
export default class AddFlightRoute extends Vue {
  isValid: boolean = false;
  dialog: boolean = true;
  isEdit: boolean = false;
  flightRoute: FlightRoute = new FlightRoute();

  data() {
    return {
      title: "Preliminary report",
      email: "",
      rules: {
        required: (value) => !!value || "Zorunlu Alan.",
      },
    };
  }

  created() {
    this.flightRoute = this.$store.state.flightRoute.editFlightRoute;
    if (this.flightRoute == null) {
      this.isEdit = false;
      this.flightRoute = new FlightRoute();
    } else {
      this.isEdit = true;
    }
  }

  async saveFlightRoute() {
    if (!this.isEdit) {
      await this.$store.dispatch({
        type: "flightRoute/saveFlightRoute",
        data: this.flightRoute,
      });

      Vue.$toast.success("Kayıt Eklendi");
      this.closeDialog();
    } else {
      await this.$store.dispatch({
        type: "flightRoute/updateFlightRoute",
        data: this.flightRoute,
      });

      Vue.$toast.success("Kayıt Güncellendi");

      this.closeDialog();
    }
  }
  closeDialog() {
    this.$emit("closed");
  }

  cancelDialog() {
    this.$emit("cancel");
    this.$store.state.flightRoute.editFlightRoute = null;
  }
}
